// @ts-check
import _ from 'lodash'

/**
 * Capitalize the first letter of the given string.
 * @param {string} string - The string to capitalize.
 * @returns {string} The capitalized string.
 */
export function upFirst (string) {
  if (!string) return ''

  return string.charAt(0).toUpperCase() + string.slice(1)
}

/**
 * Lowercase the first letter of the given string.
 * @param {string} string - The string to lowercase.
 * @returns {string} The lowercase string.
 */
export function downFirst (string) {
  if (!string) return ''

  return string.charAt(0).toLowerCase() + string.slice(1)
}

const randomCharacters = 'abcdefghijklmnopqrstuvwxyz'
/**
 * Mask the given value with the given number of characters.
 * @param {string} value - The value to mask.
 * @param {number} [keepFirstCharacters] - The number of characters to keep at the beginning.
 * @param {number} [keepLastCharacters] - The number of characters to keep at the end.
 * @param {boolean} [randomLetters] - When true, random letters are used, otherwise asterisks are used.
 * @returns {string} The masked value.
 */
export function maskedValue (value, keepFirstCharacters = 1, keepLastCharacters = 1, randomLetters = true) {
  const masked = _.times(Math.max(value.length - keepFirstCharacters - keepLastCharacters, 0), () => {
    return randomLetters ? randomCharacters[Math.round(Math.random() * 26)] : '*'
  }).join('')
  return value.slice(0, keepFirstCharacters) + masked + value.slice(value.length - keepLastCharacters)
}

/**
 * Convert the given variable name to either a singular or plural id variable name.
 * @param {string} variableName - The variable name to convert.
 * @param {boolean} isCollection - Whether the variable is a isCollection.
 * @returns {string} The id variable name. If the variable name is for a collection and ends with
 * 'categories', 'ses', or 'xes', the id variable name will be 'categoryIds', 'seIds', or
 * 'xeIds' respectively. Otherwise, the id variable name will be the variable name with 'Id' appended.
 */
export function asId (variableName, isCollection) {
  if (!isCollection) return variableName + 'Id'

  if (_.endsWith(variableName, 'categories')) {
    return 'categoryIds'
  } else if (_.endsWith(variableName, 'ses') || _.endsWith(variableName, 'xes')) {
    return variableName.slice(0, -2) + 'Ids'
  } else {
    return variableName.slice(0, -1) + 'Ids'
  }
}
